import React, {useState} from 'react';
import {Nav, Navbar, NavDropdown} from "react-bootstrap";
import {Auth} from 'aws-amplify';
import NewProjectModal from "./NewProjectModal";
// import FileUploadProgressNav from "./FileUploadProgressNav"
import ProjectListNavDropdown from "./ProjectListNavDropdown";

function signOut() {
    Auth.signOut()
        .then(() => {
            window.location.href = "/"
        })
        .catch(err => console.log(err))
}

function CustomNavbar({userName}) {

    const [showNewProjectModal, setShowNewProjectModal] = useState(false);

    return (
        <Navbar bg="dark" variant="dark" expand="sm" sticky="top">
            <Navbar.Brand>Glycoforest</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <Navbar.Text>Current project:</Navbar.Text>
                    <ProjectListNavDropdown/>
                    <Nav.Link onClick={() => setShowNewProjectModal(true)}>New Project</Nav.Link>
                    <NewProjectModal show={showNewProjectModal} onHide={() => setShowNewProjectModal(false)} onCreate={() => {setShowNewProjectModal(false);}}/>
                    {/*<Nav.Link href="#delete-project">Delete Project</Nav.Link>*/}
                    {/*<Nav.Link href="#overview">Overview</Nav.Link>*/}
                </Nav>
                <Nav>
                    <NavDropdown title={userName} id="basic-nav-dropdown">
                        <NavDropdown.Item onClick={signOut}> Sign Out </NavDropdown.Item>
                    </NavDropdown>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    )
}

export default CustomNavbar;